import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { SWRConfig } from "swr";
import { MessageType } from "../components";
import { API_ERROR_CODES } from "../constants";
import { fetcher } from "../hooks";
import { showToast } from "./toast";

interface SWRConfigWrapperProps {}

const SWRConfigWrapper = (props: PropsWithChildren<SWRConfigWrapperProps>) => {
    const { children = [] } = props;

    const { t } = useTranslation(["toast"]);

    const SWRConfigValue = {
        fetcher: fetcher,
        onError: (err: {
            ErrorCode: string;
            ErrorMessage: string;
            Status: string;
        }) => {
            switch (err.ErrorCode) {
                case API_ERROR_CODES.RECORD_ALREADY_EXIST:
                    showToast({
                        summary: t("toast:global.duplicateRecord.title"),
                        detail: t("toast:global.duplicateRecord.description"),
                        severity: MessageType.ERROR,
                    });
                    break;
                case API_ERROR_CODES.CONFIG_ERROR:
                    showToast({
                        summary: t("toast:global.configError.title"),
                        detail: err.ErrorMessage,
                        severity: MessageType.ERROR,
                    });
                    break;
                case API_ERROR_CODES.UNKNOWN:
                default:
                    console.error(
                        "An unknown error was thrown when fetching data",
                        err
                    );
                    break;
            }
        },
        onSuccess: () => {},
    };

    return <SWRConfig value={SWRConfigValue}>{children}</SWRConfig>;
};

export { SWRConfigWrapper };
